import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=f2003f40&"
import script from "./news-detail.js?vue&type=script&lang=js&"
export * from "./news-detail.js?vue&type=script&lang=js&"
import style0 from "./news-detail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports